import React, { useEffect, useState } from "react";
import axios from "../../../axios";

import FilterBar from "./FilterBar";
import TransactionTabs from "./TransactionTabs";
import SummaryCards from "./SummaryCards";
import TransactionTable from "./TransactionTable";
import Pagination from "./Pagination";

const tabs = [
  { key: "all", label: "All" },
  { key: "contest", label: "Contest" },
  { key: "question", label: "Questions" },
  { key: "recharge", label: "Recharge" },
  { key: "referral", label: "Referral" },
  { key: "refund", label: "Refund" },
  { key: "withdrawal", label: "Withdrawal" },
];

export default function CoinTransactions() {
  const [loading, setLoading] = useState(true);

  const [summary, setSummary] = useState({});
  const [transactions, setTransactions] = useState([]);
  const [pagination, setPagination] = useState({});

  const [page, setPage] = useState(1);

  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  const [activeTab, setActiveTab] = useState("all");
  const [sort, setSort] = useState("latest");

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    fetchTransactions();
  }, [page, debouncedSearch, activeTab, sort]);

  const fetchTransactions = async () => {
    try {
      setLoading(true);

      const { data } = await axios.get("/coin-transactions", {
        params: {
          page,
          limit: 25,
          search: debouncedSearch,
          tab: activeTab,
          sort,
        },
      });

      console.log(data?.data?.transactions);

      setSummary(data?.data?.summary || {});
      console.log(data?.data?.summary,"data?.data?.summary")
      setTransactions(data?.data?.transactions || []);
      setPagination(data?.data?.pagination || {});
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center py-20">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-purple-600 border-t-transparent" />
      </div>
    );
  }

  return (
    <div className="space-y-6 p-6">

      <FilterBar
        search={search}
        setSearch={setSearch}
        sort={sort}
        setSort={setSort}
        setPage={setPage}
      />

      <TransactionTabs
        tabs={tabs}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        setPage={setPage}
      />

      <SummaryCards
  summary={summary}
  activeTab={activeTab}
/>

      <TransactionTable
        transactions={transactions}
        page={page}
      />

      <Pagination
        page={page}
        totalPages={pagination?.totalPages || 1}
        setPage={setPage}
      />

    </div>
  );
}